import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/security/";

const SecurityApi = {
    switchOrganisatie(organisatieId) {
        const serviceUrl = prependRoot(routePrefix + 'switchorganisation/' + organisatieId, getApiRoot());
        return axios.get(serviceUrl, {
            headers: {
                accept: 'application/json'
            }
        });
    },
    getAuthorizationInfo() {
        const serviceUrl = prependRoot(routePrefix + "jsgetauthorization", getApiRoot());
        return axios.get(serviceUrl, {
            headers: {
                accept: 'application/json'
            }
        });
    }
};

export default SecurityApi;
